import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountExistedDialogComponent } from './account-existed-dialog/account-existed-dialog.component';
import { AccountNotExistedDialogComponent } from './account-not-existed-dialog/account-not-existed-dialog.component';
import { CommonsModule } from '../../../commons/commons.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    AccountExistedDialogComponent,
    AccountNotExistedDialogComponent,
  ],
  imports: [
    CommonModule,
    CommonsModule,
    // material design
    MatButtonModule,
  ],
  exports: [AccountExistedDialogComponent, AccountNotExistedDialogComponent],
})
export class AuthProcessComponentsModule {}
